<template>
    <el-dialog
        :style="styles"
        :visible.sync="visible"
        :title="modalObj.title"
        width="100%"
        min-height="200"
        :before-close="modalClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-table :data="modalObj.tableData" :row-class-name="tableRowClassName" max-height="700" border
            style="width: 100%" :header-cell-class-name="'tq-table-rom-header'" size="mini">
            <el-table-column prop="commitTime" label="维修日期" width="100">
                <template slot-scope="scope">
                    {{ scope.row.commitTime =scope.row.commitTime.slice(0,10) }}
                </template>
            </el-table-column>
            <el-table-column prop="team_Workers" label="维修人员" width="100" />
            <el-table-column prop="maintainItem" label="维修项目" />
            <el-table-column prop="position" label="部位" />
            <el-table-column prop="part" label="部件" />
            <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                    <span class="button-text" @click="rework(scope.row)">返修</span>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import { statementRepair } from '@/api/maintain.js'
import { Toast } from 'vant'

export default {
    name: 'Repairpopup',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        modalObj: {
            type: Object,
            default: false
        },
        repairType: {
            type: String,
            default: ''
        },
        repairItem: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            styles: null,
            tableData: []
        }
    },
    watch: {
        'modalObj'(val) {
            console.log(val, '133i')
        }
    },
    mounted() {
        if (this.modalObj.title) {
            this.styles = 'z-index:9999'
        }
    // 表单初始
    },
    methods: {
        // 返修
        rework(row) {
            this.$emit('update:visible', false) // 直接修改父组件的属性
            if (this.repairType === 'quality') {
                statementRepair({ item: this.repairItem, repairItemId: row.workOrderItemId })
                    .then(res => {
                        if (res.isSuccess) {
                            // 提交成功
                            this.$router.push({
                                path: '/StatementDetailFac',
                                query: { type: '返修结算单', id: res.data.id }
                            })
                        } else {
                            Toast.success(res.message)
                        }
                    })
            } else {
                this.$router.push({
                    path: '/fxdispatchdetails',
                    query: { type: '返修派工单', id: row.workOrderItemId }
                })
                this.$parent.getDetails()
            }
        },
        // 关闭弹出框
        modalClose() {
            this.$emit('update:visible', false) // 直接修改父组件的属性
            this.$emit('onRepairPopupClose')
        }
    }
}
</script>
